<!--suppress ALL -->
<template>
  <div>
    <ellipse-bg />
    <z-nav />

    <div class="mt-20 max-w-lg mx-auto">

      <!-- No update needeed / Error message -->
      <div
        v-if="
          !$store.state.queryIdInfoResult ||
          $store.state.queryIdInfoResult === 'error'
        "
        class="text-center whitespace-pre-line">
        <div v-if="$store.state.errorMessage === 'NoUpdateNeeded'">
          {{ $t('NoUpdateNeeded') }}
        </div>
        <div v-else>
          {{ $t('AnErrorOccurred') }}
        </div>
      </div>

      <!-- Main kyc page - Got server response -->
      <div v-else-if="$store.state.queryIdInfoResult">

        <!-- Number and meta/info -->
        <div class="block">
          <h2 class="text-sm font-medium text-black">
            {{ $t('MobileNumber') }}
          </h2>
          <p class="font-bold text-black">
            {{ $store.state.queryIdInfoResult.msisdn }}
          </p>
        </div>

        <!-- Initial Civil ID Input  -->
        <update-form v-if="!$store.state.updateIdInfoResult" class="mt-4" />

        <!-- Flow: PACI -->
        <div v-else-if="isPaciFlow">
          <p>{{ $t('ShouldReceiveAuthenticationFromPaci') }}</p>
          <tutorial tutorial-name="existing_user" />
        </div>

        <!-- Flow: Scan -->
        <scan-flow v-else-if="isScanFlow" />

        <!-- Bad request message -->
        <div v-else-if="resultStatus === 'Bad Request'">
          {{ $t('AnErrorOccurred') }}
          <br /><br />

          <z-button
            class="w-full"
            @click="$store.state.updateIdInfoResult = null">
            {{ $t('TryAgain') }}
          </z-button>
        </div>

        <!-- MOCK STUFF -->
        <div
          v-if="$store.state.updateIdInfoResult && $store.state.isMock"
          class="mt-12 p-6 rounded-md bg-gray-100 text-sm">
          <p class="mb-3 font-bold">Mock GET /paci-update/auth</p>

          <div class="flex items-center space-x-3">
            <input
              v-model="mockDebugGetPaciStatus"
              :value="null"
              name="mockDebug"
              type="radio" />
            <span class="text-red-600">No Mock</span>
          </div>

          <div class="flex items-center space-x-3">
            <input
              v-model="mockDebugGetPaciStatus"
              name="mockDebug"
              type="radio"
              value="UserAccepted" />
            <span>Mock UserAccepted ("status": "UserAccepted")</span>
          </div>

          <div class="flex items-center space-x-3">
            <input
              v-model="mockDebugGetPaciStatus"
              name="mockDebug"
              type="radio"
              value="UserDeclined" />
            <span>Mock UserDeclined ("status": "UserDeclined")</span>
          </div>

          <div class="flex items-center space-x-3">
            <input
              v-model="mockDebugGetPaciStatus"
              name="mockDebug"
              type="radio"
              value="Not Found" />
            <span>Mock Not Found ("status": "Not Found")</span>
          </div>

          <div class="flex flex-col space-y-3 mt-10 text-xs">
            <div>
              <div class="flex space-x-3">
                <p class="flex-grow">{{ $t('SavedPaciAuth') }}</p>
                <p
                  v-if="
                    $store.state.paciRequestDate &&
                    $store.state.paciRequestDate.toLocaleTimeString
                  ">
                  {{ $store.state.paciRequestDate.toLocaleTimeString() }}
                </p>
                <a
                  class="underline cursor-pointer"
                  @click="$store.dispatch('setPaciRequestId', null)"
                  >{{ $t('Clear') }}</a
                >
              </div>
              <pre class="bg-gray-200 p-3 rounded-md mt-2">
              {{ $store.state.paciRequestId }}</pre
              >
            </div>
            <div>
              POST /paci-update/auth
              <pre class="bg-gray-200 p-3 rounded-md mt-2">
              {{ $store.state.updateIdInfoResult }}
            </pre
              >
            </div>
            <div>
              GET /paci-update/auth
              <pre class="bg-gray-200 p-3 rounded-md mt-2">
              {{ $store.state.queryRequestStatusResult }}
            </pre
              >
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import UpdateForm from '@/components/UpdateForm'
import Tutorial from '@/components/Tutorial'
import EllipseBg from '@/components/EllipseBg'
import ZNav from '@/components/ZNav'
import ScanFlow from '@/pages/kyc/ScanFlow'

export default {
  name: 'HomeKyc',
  components: { ScanFlow, ZNav, EllipseBg, Tutorial,  UpdateForm },
  computed: {
    isPaciFlow() {
      return (
        this.$store.state.updateIdInfoResult &&
        this.$store.state.updateIdInfoResult.isSuccess &&
        (this.$store.state.updateIdInfoResult.result
          ? this.$store.state.updateIdInfoResult.result.status
          : '') === 'Success'
      )
    },
    isScanFlow() {
      return ['User is not eligible', 'No Identity/Device Found '].includes(
        this.resultStatus
      )
    },
    resultStatus() {
      return this.$store.state.updateIdInfoResult?.result?.status ?? ''
    }
  },
  data() {
    return {
      mockDebugGetPaciStatus: null
    }
  },
  watch: {
    mockDebugGetPaciStatus(val) {
      console.log(val)

      if (val) {
        this.$store.state.queryRequestStatusResult = {
          isSuccess: true,
          result: {
            status: val
          }
        }
      }
    }
  }
}
</script>
